module.exports = __webpack_public_path__ + "static/media/Lifebuoy.477b5e5d.svg";